import { defineComponent as o, openBlock as r, createBlock as n, unref as m, mergeProps as p, withCtx as h, createElementVNode as c } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconChart",
  __name: "IconChart",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (v, e) => (r(), n(m(s), p(t, { "view-box": "0 0 24 24" }), {
      default: h(() => [...e[0] || (e[0] = [
        c("path", { d: "M10.5 6.125a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-9M6 9.625a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H6m-1.5 7.25a.75.75 0 0 0 0 1.5h15a.75.75 0 0 0 0-1.5h-15m11.5-5.25a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-2" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
